import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    getListUserCanAddToProject,
    handleAddNew, handleSelectUserAddToProject,
    isDisableBtnSubmit,
    isDisableBtnDeleteProjectUser,
    onClickCancelEdit, onClickDeleteProjectUser, onDeleteAddUser,
    onSubmit,
    getUserList,
    onChangePermissionForUserInProject,
    onChangePermissionForNewUserInProject,
    checkUserPermissions,
    checkUserPrivilege
} from '@/component/project/handler/ProjectUserManagementHandler';
import { getUserListInProjectByProjectId } from '@/service/userService';
import { getUserListByProjectAtom } from '@/state/atom/userAtom';
import { getUserListByProjectSelector } from '@/state/selector/userSelector';
import {
    Button,
    FormControl, IconButton,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import OverFlowTooltip from '../common/OverFlowTooltip';
// import ConfirmModalDelete from '../system/ConfirmModalDelete';
import { DialogConfirmCreateTicketError } from '@/component/ticketList/addTicketDialog/DialogConfirmCreateTicketError';
import CancelDialogAddUser from './dialog/CancelDialogAddUser';
import RejectDeleteProjectUser from './dialog/RejectDeleteProjectUser';
import './ProjectUserManagement.css';
import ConfirmDeleteUserProject from './dialog/ConfirmDeleteUserProject';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function UserListInProject(props) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const { isProjectManager, userDetail, projectDetail, isAdmin } = props;
    const [listUserAddToProject, setListUserAddToProject] = useState([]);
    const [userAddToProject, setUserAddToProject] = useState();
    const [userChangePermissionProjectList, setUserChangePermissionProjectList] = useState([]);
    const [userAddList, setUserAddList] = useState([]);
    const [errors, setErrors] = useState({});
    const [openConfirmModal, setOpenConfirmModal] = useState({ isOpen: false, userId: null });
    const [openCancelDialog, setOpenCancelDialog] = useState(false);

    const [userListRecoilValue] = useRecoilState(getUserListByProjectAtom);
    const setUserListRecoilValue= useSetRecoilState(getUserListByProjectSelector);
    let [userList, setUserList] = useState([]);
    const [isOpenModalRejectDeleteProjectUser, setIsOpenModalRejectDeleteProjectUser] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isOpenDialogMaxLimitValue, setIsOpenDialogMaxLimitValue] = useState(false);
    const [messageDialogMaxLimitValue, setMessageDialogMaxLimitValue] = useState(false);
    const [updateUserListError, setUpdateUserListError] = useState('');

    let argsAll = {
        ...props,
        userList, 
        setUserList,
        listUserAddToProject,
        setListUserAddToProject,
        userAddToProject,
        setUserAddToProject,
        userChangePermissionProjectList,
        setUserChangePermissionProjectList,
        setUserAddList,
        userAddList,
        setErrors,
        errors,
        openConfirmModal,
        setOpenConfirmModal,
        userListRecoilValue,
        setUserListRecoilValue,
        openCancelDialog,
        setOpenCancelDialog,
        isOpenModalRejectDeleteProjectUser,
        setIsOpenModalRejectDeleteProjectUser,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        isOpenDialogMaxLimitValue,
        setIsOpenDialogMaxLimitValue,
        messageDialogMaxLimitValue,
        setMessageDialogMaxLimitValue,
        setUpdateUserListError
    };

    useEffect(() => {
        let userListClone = cloneDeep(userListRecoilValue);
        let userListInProject = userListClone?.filter(user => user.type !== Constant.USER_TYPE.CUSTOMER && user?.projectDetail?.active !== Constant.ACTIVE_FLAG.DELETED);
        setUserList(userListInProject);
    }, [userListRecoilValue]);

    useEffect(() => {
        // get list user add to project
        props.setIsLoading(true);
        getListUserCanAddToProject(argsAll).then(() => {
            getUserListInProjectByProjectId(props?.API, projectDetail.id).then(userRes => {
                let userListInProject = userRes?.filter(user => user.type !== Constant.USER_TYPE.CUSTOMER);
                setUserListRecoilValue(userListInProject)
                props.setIsLoading(false);
            })
        });
    }, []);

    useEffect(() => {
        let isCancelTab = false;
        if(!Utils.isEmptyArray(userAddList) || !Utils.isEmptyArray(userChangePermissionProjectList)) {
            isCancelTab = true;
        }
        return props.parentCallBack(isCancelTab)
    },[userAddList, userChangePermissionProjectList])

    const reloadPage = async () => {
        await getUserList(argsAll);
        await getListUserCanAddToProject(argsAll);
        setListUserAddToProject([]);
        setUserChangePermissionProjectList([]);
        setUserAddList([]);
        setErrors({});
    }

    const renderTblUserList = () => {
        let listItems =
            !Utils.isEmptyArray(userList) &&
            userList?.map((user, i) => (
                <TableRow key={user.id}>
                    <TableCell>
                        <div className="table--column-avatar-user">
                            <div className="fixed-with-avatar">
                                <img src={user.avatar} alt="" width="24px" />
                            </div>
                            <span className="break-word-email">{Utils.getDisplayUserEmailWithoutSuffix(user.mail)}</span>
                        </div>
                    </TableCell>
                    <TableCell>
                        <OverFlowTooltip
                            value={Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                user.lastName
                            )}
                        />
                    </TableCell>
                    <TableCell>
                        <OverFlowTooltip
                            value={Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                user.firstName
                            )}
                        />
                    </TableCell>
                    <TableCell>{Utils.getUserType(user.type)}</TableCell>
                    <TableCell className="groupBtn">
                        <div className="switch-check" style={{ padding: '3px 0 0 0' }}>
                            <input
                                type="checkbox"
                                id={`user_${user.id}`}
                                defaultChecked={checkUserPermissions(user)}
                                checked={checkUserPermissions(user)}
                                onChange={e => onChangePermissionForUserInProject(i,
                                    e,
                                    userList,
                                    userChangePermissionProjectList,
                                    argsAll)}
                                disabled={!isProjectManager}
                            />
                            <label htmlFor={`user_${user.id}`}></label>
                        </div>
                    </TableCell>
                    <TableCell className="groupBtn">
                        <IconButton
                            className={
                                isDisableBtnDeleteProjectUser(argsAll)
                                    ? 'erase disabled-btn'
                                    : 'erase'
                            }
                            onClick={() => onClickDeleteProjectUser(argsAll, user)}
                            disabled={isDisableBtnDeleteProjectUser(argsAll)}
                        >
                            <img src="/assets/image/delete-icon.svg" alt="" />
                        </IconButton>
                    </TableCell>
                </TableRow>
            ));

        let tbl = (
            <div className="table-tbl table-tbl--account">
                <Table style={{borderCollapse: 'separate', borderSpacing: 0}}>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell></TableCell> */}
                            <TableCell>{trI18n('AUTH01LB001')}{trI18n('USER09LB001')}</TableCell>
                            <TableCell>{trI18n('USER01LB003')}</TableCell>
                            <TableCell>{trI18n('USER01LB004')}</TableCell>
                            <TableCell>{trI18n('USER01LB016')}</TableCell>
                            <TableCell className="toggle-project" >{trI18n('TAGBTN021')}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    {isProjectManager &&
                        projectDetail.type !== Constant.PROJECT_TYPE.BASE &&
                        renderTblAddUserToProject()}
                    <TableBody>{listItems}</TableBody>
                </Table>
            </div>
        );
        return tbl;
    };

    const renderTblAddUserToProject = () => {
        return (
            <TableBody>
                {!Utils.isEmptyArray(userAddList) &&
                    userAddList.map((user, index) => (
                        <TableRow key={user.id}>
                            {/* select box email type in general  */}
                            <TableCell>
                                <FormControl variant="outlined" className="form-control">
                                    <Select
                                        error={errors[user.id] && errors[user.id].mail}
                                        value={!user.userDetail?.id ? user.userDetail.id : ''}
                                        onChange={e =>
                                            handleSelectUserAddToProject(
                                                argsAll,
                                                user.id,
                                                e.target.value,
                                                listUserAddToProject
                                            )
                                        }
                                        data-cy="project-user-select-username"
                                    >
                                        {listUserAddToProject.map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.mail}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <span style={{color: 'red'}}>
                                        {errors[user.id] && errors[user.id].mail}
                                    </span>
                                </FormControl>
                            </TableCell>
                            {/* last name  */}
                            <TableCell>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-outline user-name "
                                    value={
                                        user.userDetail
                                            ? Utils.getTextByLanguage(
                                                  Constant.LANGUAGE_TYPE.JP,
                                                  user.userDetail.lastName
                                              )
                                            : ''
                                    }
                                />
                            </TableCell>
                            {/* first name  */}
                            <TableCell>
                                <OverFlowTooltipWithTabsMui
                                    className="knowledge-outline user-name "
                                    value={
                                        user.userDetail
                                            ? Utils.getTextByLanguage(
                                                  Constant.LANGUAGE_TYPE.JP,
                                                  user.userDetail.firstName
                                              )
                                            : ''
                                    }
                                />
                            </TableCell>
                            {/* type  */}
                            <TableCell>
                                {Utils.getUserType(Constant.USER_TYPE.GENERAL)}
                            </TableCell>
                            {/* role  */}
                            <TableCell className="groupBtn">
                                <div className="switch-check" style={{ padding: '3px 0 0 0' }}>
                                    <input
                                        type="checkbox"
                                        id={`user_${user.id}`}
                                        defaultChecked={false}
                                        checked={checkUserPrivilege(user)}
                                        disabled={!user.userDetail.privilege}
                                        onChange={e => onChangePermissionForNewUserInProject(
                                            index,
                                            e,
                                            argsAll)}
                                    />
                                    <label htmlFor={`user_${user.id}`}></label>
                                </div>
                            </TableCell>
                            {/* delete  */}
                            <TableCell className="groupBtn">
                                <IconButton
                                    className="erase"
                                    onClick={() => onDeleteAddUser(argsAll, user.id)}
                                >
                                    <img src="/assets/image/delete-icon.svg" alt="" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
            </TableBody>
        );
    };

    return (
        <>
            <div className="groupUser" data-cy="project-user-list">
                <div className="head-btn">
                    <div className="head-btn-add">
                        <Button
                            className="btn-add-project"
                            onClick={() => handleAddNew(argsAll)}
                            disabled={!isProjectManager}
                        >
                            <div className="btn-plus-icon">
                                {isProjectManager && 
                                    <img src="/assets/image/icon-plus-add.svg" alt="" />
                                }
                            </div>
                            <div className="btn-text-add">{trI18n('USER03BTN005')}</div>
                        </Button>
                    </div>

                    <div className="head-btn-wrap">
                        <div className="btn-cancel">
                            <Button
                                className="btn-light btn-hg32"
                                variant="contained"
                                color="primary"
                                disabled={(Utils.isEmptyArray(userAddList) && Utils.isEmptyArray(userChangePermissionProjectList))}
                                onClick={() => onClickCancelEdit(argsAll)}
                            >
                                {trI18n('COMBTN001')}
                            </Button>
                        </div>
                        <div className="btn-submit">
                            <Button
                                className="btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                    onSubmit(
                                        argsAll,
                                        userDetail,
                                        projectDetail,
                                        isProjectManager,
                                        userChangePermissionProjectList
                                    )
                                }
                                disabled={isDisableBtnSubmit(
                                    userChangePermissionProjectList,
                                    userAddList
                                )}
                            >
                                {trI18n('COMBTN011')}
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="projectUser-table" data-cy="project-users-table-list">
                    {userList && renderTblUserList()}
                </div>
            </div>
            {/* Cofirm modal delete user*/}
            <ConfirmDeleteUserProject openConfirmModal={openConfirmModal} argsAll={argsAll} />
            {/* <ConfirmModalDelete openConfirmModal={openConfirmModal} argsAll={argsAll} /> */}
            <CancelDialogAddUser isOpen={openCancelDialog} argsAll={argsAll} />
            {isOpenModalRejectDeleteProjectUser && (
                <RejectDeleteProjectUser {...argsAll} isOpen={isOpenModalRejectDeleteProjectUser} setIsOpen={setIsOpenModalRejectDeleteProjectUser} />
            )}

            {isOpenModalReloadPage && (
                <DialogConfirmCreateTicketError {...argsAll} isOpen={isOpenModalReloadPage} setIsOpen={setIsOpenModalReloadPage} onSubmit={reloadPage} />
            )}
            <ConfirmDialog 
                isOpen={isOpenDialogMaxLimitValue} 
                okCallBack={() => {setIsOpenDialogMaxLimitValue(false)}} 
                msgConfirm={messageDialogMaxLimitValue}
                textSubmit={trI18n('COMBTN006')}
            />

            <ConfirmDialog 
                isOpen={!Utils.isEmptyString(updateUserListError)} 
                okCallBack={() => {setUpdateUserListError('')}} 
                msgConfirm={updateUserListError}
                textSubmit={trI18n('COMBTN006')}
            />
        </>
    );
}
